import { Controller } from "@hotwired/stimulus"

// Submits the host <form> as soon as a wired input fires the configured
// event. Used on the listener Home profile form so picking a new avatar
// uploads + re-renders immediately, mirroring how other media uploads in
// the app save on selection rather than waiting for an explicit Save click.
//
// Usage:
//   <form data-controller="auto-submit">
//     <input type="file" data-action="change->auto-submit#submit">
//   </form>
//
// Lives on the form (not the input) so the file input itself stays a
// plain unattributed `<input type="file">` — the prior pattern of
// data-controller + data-target on a visually-hidden file input
// reproducibly broke avatar uploads in real Chrome.
export default class extends Controller<HTMLFormElement> {
  submit() {
    this.element.requestSubmit()
  }
}
